//导入根组件  _that 指向Vue
import _that from '../../src/main'

//返回的公共方法对象
let tools = {
  showMessage: function (info) {
    alert(info)
  },
  //页面跳转
  pageRedirected: function (data = "", url = "/") {
    // console.log(data);
    // 路由中 name 获取 params 参数  path 获取 query 参数 传参的时候也要搭配使用 params不会在url中显示data
    _that.$router.push({name: url, params: {data: data}})
  },

  // 密码校验
  passwordCheck(password){
    // var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/; 数字  字母  少了符号  @change = 'passwordChange'
    let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[])+$)([^(0-9a-zA-Z)]|[]|[a-zA-Z]|[0-9]){6,16}$/;
    // 此校验  0 不是空
    if(!reg.test(password)) {
      return true
    }
    else return false
  },

  //  对象非空校验
  objectNotNullCheck(obj){
    for( let k in obj){
      if(obj[k]===''){
        return true
      }
    }
    return false;
  },

  //  整数校验
  isInteger(value){
    if (!/^[0-9]\d*$/.test(value)) {
      return true
    }else return false
  },

  // 英文和数字校验 [0-9a-zA-z]
  isIntAndEg(value){
    if (/^[0-9a-zA-z]*$/.test(value)) {
      return true
    }else return false
  },

  //图片预览路径
  getObjectURL(file) {
    let url = null;
    if (window.createObjectURL !== undefined) { // basic
      url = window.createObjectURL(file);
    } else if (window.URL !== undefined) { // mozilla(firefox)
      url = window.URL.createObjectURL(file);
    } else if (window.webkitURL !== undefined) { // webkit or chrome
      url = window.webkitURL.createObjectURL(file);
    }
    // console.log("文件路径----------------------------");
    // console.log(url);
    return url;
  },

};

export default {
  install: function (Vue) {
    Vue.prototype.tools = tools
  }
}
// export default tools



// WEBPACK FOOTER //
// ./src/tools/index.js